import React, { useEffect, useState } from "react";
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import MoodBadIcon from '@mui/icons-material/MoodBad';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';

const ratingIconSets = {
    1: {
        1: <SentimentNeutralIcon />
    },
    2: {
        1: <SentimentDissatisfiedIcon />,
        2: <SentimentSatisfiedIcon />
    },
    3: {
        1: <SentimentVeryDissatisfiedIcon />,
        2: <SentimentNeutralIcon />,
        3: <SentimentVerySatisfiedIcon />
    },
    4: {
        1: <SentimentVeryDissatisfiedIcon />,
        2: <SentimentDissatisfiedIcon />,
        3: <SentimentSatisfiedIcon />,
        4: <SentimentVerySatisfiedIcon />
    },
    5: {
        1: <SentimentVeryDissatisfiedIcon />,
        2: <SentimentDissatisfiedIcon />,
        3: <SentimentNeutralIcon />,
        4: <SentimentSatisfiedIcon />,
        5: <SentimentVerySatisfiedIcon />
    },
    6: {
        1: <SentimentVeryDissatisfiedIcon />,
        2: <MoodBadIcon />,
        3: <SentimentDissatisfiedIcon />,
        4: <SentimentSatisfiedIcon />,
        5: <SentimentSatisfiedAltIcon />,
        6: <SentimentVerySatisfiedIcon />
    },
    7: {
        1: <SentimentVeryDissatisfiedIcon />,
        2: <MoodBadIcon />,
        3: <SentimentDissatisfiedIcon />,
        4: <SentimentNeutralIcon />,
        5: <SentimentSatisfiedIcon />,
        6: <SentimentSatisfiedAltIcon />,
        7: <SentimentVerySatisfiedIcon />
    }
};
const colors = {
    1: {
        1: { icon: '#15803d', background: '#dcfce7', border: '#86efac' }   // Neutral
    },
    2: {
        1: { icon: '#dc2626', background: '#fee2e2', border: '#fca5a5' },  // Dissatisfied
        2: { icon: '#16a34a', background: '#dcfce7', border: '#86efac' }   // Satisfied
    },
    3: {
        1: { icon: '#b91c1c', background: '#fee2e2', border: '#fca5a5' },  // Very Dissatisfied
        2: { icon: '#d97706', background: '#fffbeb', border: '#fcd34d' },  // Neutral
        3: { icon: '#15803d', background: '#dcfce7', border: '#86efac' }   // Very Satisfied
    },
    4: {
        1: { icon: '#b91c1c', background: '#fee2e2', border: '#fca5a5' },  // Very Dissatisfied
        2: { icon: '#dc2626', background: '#fee2e2', border: '#fca5a5' },  // Dissatisfied
        3: { icon: '#16a34a', background: '#dcfce7', border: '#86efac' },  // Satisfied
        4: { icon: '#15803d', background: '#dcfce7', border: '#86efac' }   // Very Satisfied
    },
    5: {
        1: { icon: '#b91c1c', background: '#fee2e2', border: '#fca5a5' },  // Very Dissatisfied
        2: { icon: '#dc2626', background: '#fee2e2', border: '#fca5a5' },  // Dissatisfied
        3: { icon: '#d97706', background: '#fffbeb', border: '#fcd34d' },  // Neutral
        4: { icon: '#16a34a', background: '#dcfce7', border: '#86efac' },  // Satisfied
        5: { icon: '#15803d', background: '#dcfce7', border: '#86efac' }   // Very Satisfied
    },
    6: {
        1: { icon: '#b91c1c', background: '#fee2e2', border: '#fca5a5' },  // Very Dissatisfied
        2: { icon: '#dc2626', background: '#fee2e2', border: '#fca5a5' },  // Mood Bad
        3: { icon: '#ef4444', background: '#fee2e2', border: '#fca5a5' },  // Dissatisfied
        4: { icon: '#16a34a', background: '#dcfce7', border: '#86efac' },  // Satisfied
        5: { icon: '#15803d', background: '#dcfce7', border: '#86efac' },  // Satisfied Alt
        6: { icon: '#166534', background: '#dcfce7', border: '#86efac' }   // Very Satisfied
    },
    7: {
        1: { icon: '#991b1b', background: '#fee2e2', border: '#fecaca' },  // Very Dissatisfied (Dark Red)
        2: { icon: '#dc2626', background: '#fef2f2', border: '#fca5a5' },  // Mood Bad (Bright Red)
        3: { icon: '#ea580c', background: '#fff7ed', border: '#fdba74' },  // Dissatisfied (Orange)
        4: { icon: '#d97706', background: '#fffbeb', border: '#fcd34d' },  // Neutral (Amber)
        5: { icon: '#65a30d', background: '#f7fee7', border: '#bef264' },  // Satisfied (Lime Green)
        6: { icon: '#16a34a', background: '#ecfdf5', border: '#6ee7b7' },  // Satisfied Alt (Green)
        7: { icon: '#15803d', background: '#f0fdf4', border: '#4ade80' }   // Very Satisfied (Dark Green)
    }
};
// Update getColorByIndex to use the new structure
const getColorByIndex = (index, totalStars) => {
    return colors[totalStars]?.[index] || { icon: '#d1d5db', background: '#ffffff', border: '#e5e7eb' };
};

// Star component remains the same
const Star = ({ filled, onClick, label, index, totalStars }) => {
    const colorSet = filled ? getColorByIndex(index, totalStars) : { icon: '#d1d5db', background: '#ffffff', border: '#e5e7eb' };

    return (
        <div
            onClick={onClick}
            className="inline-flex text-center flex-col rating-card items-center justify-center  min-h-16 p-2 rounded-md shadow-sm hover:shadow-md transition-all cursor-pointer"
            style={{
                backgroundColor: colorSet.background,
                borderColor: colorSet.border,
                borderWidth: '1px',
                borderStyle: 'solid',
                boxShadow: filled ? `0 4px 6px -1px ${colorSet.border}40, 0 2px 4px -2px ${colorSet.border}20` : 'none',
                transform: filled ? 'translateY(-1px)' : 'none'
            }}
        >
            <span className="text-2xl" style={{ color: colorSet.icon }}>
                {ratingIconSets[totalStars][index]}
            </span>
            <span className="text-xs text-gray-600 mt-1 w-full rating-label" title={label}>
                {label}
            </span>
        </div>
    );
};

const StarNoContainer = ({ filled, onClick, label, index, totalStars }) => (
    <div onClick={onClick} className="inline-flex flex-col items-center p-1 cursor-pointer StarNoContainer">
        <span style={{ color: filled ? getColorByIndex(index, totalStars).icon : '#d1d5db' }}>
            {ratingIconSets[totalStars][index]}
        </span>
        <span className="text-xs text-gray-600 mt-1" title={label}>
            {label }
        </span>
    </div>
);

const Rating = ({ totalStars, initialRating, onRating, ratingLabels, variant = '', index }) => {
    const [rating, setRating] = useState(0);
    const handleClick = (starIndex, label) => {
        const newRating = rating === starIndex ? 0 : starIndex;
        setRating(newRating);
        onRating(newRating, label, index);
    };
    useEffect(() => {
        setRating(initialRating);
    }, [initialRating])
    const StarComponent = variant === 'simple' ? StarNoContainer : Star;
    return (
        <div className="inline-flex flex-col items-center">
            <div className="flex gap-2 flex-wrap">
                {[...Array(totalStars)].map((_, index) => (
                    <StarComponent
                        key={index}
                        totalStars={totalStars}
                        index={index + 1}
                        filled={index + 1 === rating}
                        onClick={() => handleClick(index + 1, ratingLabels?.[index + 1] || '')}
                        label={ratingLabels?.[index + 1] || ''}
                    />
                ))}
            </div>
        </div>
    );
};

export default Rating;

